// extracted by mini-css-extract-plugin
module.exports = {"icon":"CustomPhoneType_icon__1dUCX"};